import axios from "axios";
import { proxyUrl } from "../config";
import { setupInterceptorsTo } from "./Interceptors";
setupInterceptorsTo(axios);

interface IStatusBar {
  id: number;
  date: Date;
  canDelete: boolean;
  text: string;
  type: string;
  severityOrder: number;
  isGeneralNotification: boolean;
}

export type StatusBarModel = IStatusBar;

class StatusBarService {
  public GetAllStatusBarEnabled = async (
    userId: number
  ): Promise<StatusBarModel[]> => {
    let url: string = `${proxyUrl}/GetAllStatusBarEnabled/${userId}`;
    const req = await axios.get(url);
    return req.data;
  };

  public setReadNotification = async (
    userCommunicationId: number
  ): Promise<boolean> => {
    let url: string = `${proxyUrl}/userCommunications/${userCommunicationId}/markAsRead`;
    const req = await axios.post(url);
    return req.data;
  };

  public setReadStatusBarNotification = async (
    statusBarId: number
  ): Promise<boolean> => {
    let url: string = `${proxyUrl}/statusBars/${statusBarId}/markAsRead`;
    const req = await axios.post(url);
    return req.data;
  };
}

const StatusService = new StatusBarService();
export default StatusService;
